/** Footer state when primary submit is anchored to ActionModal (mobile). */
export interface CircleFormFooterStateBase {
  isSubmitting: boolean;
}

export interface CreateCircleFormFooterState extends CircleFormFooterStateBase {
  hasReachedLimit: boolean;
  selectedUsersCount: number;
  limitMessage: string;
}

export type EditCircleFormFooterState = CircleFormFooterStateBase;

export const INITIAL_CIRCLE_FORM_FOOTER: CircleFormFooterStateBase = {
  isSubmitting: false,
};

export const INITIAL_CREATE_CIRCLE_FORM_FOOTER: CreateCircleFormFooterState = {
  ...INITIAL_CIRCLE_FORM_FOOTER,
  hasReachedLimit: false,
  selectedUsersCount: 0,
  limitMessage: "",
};
